import { useAppSelector } from '@/redux/rootReducer'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'
import { Role } from '@/core/types/shared'

/**
 * Hook to get the establishment ID from the authenticated user
 * @returns The establishment ID or null if not available
 */
export function useEstablishmentAuth() {
  const authUser = useAppSelector(selectAuthUser)
  const establishmentId = authUser?.establishment?._id
  const isSuperAdmin = authUser?.roles?.includes(Role.SuperAdmin) ?? false

  return { establishmentId, isSuperAdmin }
}
